
export const formatUserRole = (role: string | null | undefined) => {
  if (!role) return "";

  // Handle snake_case like "claim_administrator"
  if (role.includes("_")) {
    return role
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  // Handle all lowercase like "consultant"
  return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
};
